import type { ClassValue } from 'clsx';
import type { LiteralUnion } from '/types/index.d';

import { customTwMerge } from '../util/customTwMerge';
import React from 'react';


export function Row({
	as,
	children,
	className,
	...otherProps
}: Omit<
	React.HTMLAttributes<HTMLElement>,
	'className'
> & {
	as?: LiteralUnion<keyof JSX.IntrinsicElements>;
	children?: React.ReactNode
	className?: ClassValue
}): React.JSX.Element {
	const ElementType = (as || 'div') as React.ElementType;
	return (
		<ElementType
			className={customTwMerge('flex flex-row justify-between gap-xl', className)}
			{...otherProps}
		>
			{children}
		</ElementType>
	);
}
